import { Avatar, HStack, Text, BoxProps } from '@chakra-ui/react';
import dayjs from 'dayjs';

export type ArticleAuthorProps = {
  date: Date;
  name: string;
} & BoxProps;

export const ArticleAuthor: React.FC<ArticleAuthorProps> = ({
  date,
  name,
  ...rest
}: ArticleAuthorProps) => {
  return (
    <HStack
      marginTop="2"
      spacing="2"
      display="flex"
      alignItems="center"
      {...rest}
    >
      <Avatar borderRadius="full" boxSize="40px" src="/mike.jpg" />
      <Text fontWeight="normal" fontSize="md">
        {name}
      </Text>
      <Text fontWeight="normal" fontSize="md">
        —
      </Text>
      <Text fontWeight="normal" fontSize="md">
        {dayjs(date).format('MM/D/YYYY')}
      </Text>
    </HStack>
  );
};
